export enum UserRole {
  owner = "owner",
  admin = "admin",
  maintainer = "maintainer",
  guest = "guest",
  customer = "customer",
}

export const userRoleAsString = (userRole: UserRole | string): string => {
  switch (userRole) {
    case UserRole.owner:
      return `Leedflow (Propriétaire)`;
    case UserRole.admin:
      return `Leedflow (Administrateur)`;
    case UserRole.maintainer:
      return `Leedflow (Mainteneur)`;
    case UserRole.guest:
      return `Leedflow (Invité)`;
    case UserRole.customer:
      return "Client";
    default:
      return "";
  }
};